const resolveSegmentField = (field: string): string => {
  switch (field) {
    case 'cumulativePace':
      return 'segmentCumulativePace';
    case 'pace':
      return 'segmentPace';
    default:
      return field;
  }
};

export default resolveSegmentField;
